import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { withStyles } from '@material-ui/core/styles'
import store from '../../store'
import { getSalaryInfo, saveSalarySlip } from '../../actions/index'
import FontAwesome from 'react-fontawesome'

const styles = (theme) => ({
  tablecell: {
    fontSize: '12px',
    maxWidth: '200px',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    [theme.breakpoints.down('xs')]: {
      padding: '0 10px'
    }
  }
})

const space = (string) => {
  const spaced = string.replaceAll(',', ', ')
  return spaced
}

const SalaryRow = ({
  index,
  id,
  invoice_uuid,
  date,
  invoice_id,
  invoice_sum,
  gross_sum,
  net_sum,
  allowance_cost,
  expense_cost,
  status,
  classes
}) => (
  <TableRow
    key={id}
    style={index % 2 ? { background: 'white' } : { background: '#ebf9fa' }}
  >
    <TableCell component="th" scope="row" className={classes.tablecell}>
      {date}
    </TableCell>
    <TableCell
      component="th"
      scope="row"
      className={classNames(classes.tablecell, 'hide-mobile')}
      style={{ wordWrap: 'break-word' }}
    >
      {space(invoice_id)}
    </TableCell>
    <TableCell
      component="th"
      scope="row"
      className={classNames(classes.tablecell, 'hide-mobile')}
    >
      {invoice_sum}
    </TableCell>
    <TableCell component="th" scope="row" className={classes.tablecell}>
      {gross_sum}
    </TableCell>
    <TableCell
      component="th"
      scope="row"
      className={classNames(classes.tablecell, 'hide-mobile')}
    >
      {net_sum}
    </TableCell>
    <TableCell
      component="th"
      scope="row"
      className={classNames(classes.tablecell, 'hide-mobile')}
    >
      {allowance_cost}
    </TableCell>
    <TableCell
      component="th"
      scope="row"
      className={classNames(classes.tablecell, 'hide-mobile')}
    >
      {expense_cost}
    </TableCell>
    <TableCell
      component="th"
      scope="row"
      className={classNames(classes.tablecell, 'hide-mobile')}
    >
      {status}
    </TableCell>
    <TableCell component="th" scope="row" className={classes.tablecell}>
      <div style={{ display: 'flex' }}>
        <p
          style={{ marginLeft: '10px', marginRight: '15px' }}
          className="link"
          onClick={() => {
            store.dispatch(getSalaryInfo(id))
          }}
        >
          <FontAwesome name="info-circle" />
        </p>
        <p
          style={{ marginLeft: '10px', marginRight: '15px' }}
          className="link"
          onClick={() => {
            store.dispatch(saveSalarySlip(id, invoice_uuid))
          }}
        >
          <FontAwesome name="file-pdf-o" />
        </p>
      </div>
    </TableCell>
  </TableRow>
)

SalaryRow.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(SalaryRow)
